import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import { Box, Stack } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import ActionDetails from "../../components/mui/GlobalAnchor/ActionDetails";
import GlobalAnchorList from "../../components/mui/GlobalAnchor/GlobalAnchorList";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { getUimodules } from "../../redux/features/uimoduleSlice";
import AddUimodule from "./AddUimodule";
import EditUimodule from "./EditUimodule";
import { Uimodules_table_head } from "../../components/datagrid/uimodules/UimodulesTableHead";
import DeleteUimodule from "./DeleteUimodule";

const Uimodule = () => {
  const dispatch = useDispatch();
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { uimodules, loading } = useSelector((state) => state.uimodule);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  const [value, setValue] = useState(dayjs());

  const data = {
    page: pageNum,
    limit: gridSize,
    date: dayjs(value).format("YYYY-MM"),
  };

  useEffect(() => {
    if (pageNum) {
      dispatch(getUimodules(data));
    }
  }, [pageNum, gridSize, value]);

  return (
    <GlobalWrapper
      title={"UI Modules"}
      actions={<AddUimodule dispatchdata={data} />}
    >
      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={Uimodules_table_head}
          rows={uimodules.data}
          meta={uimodules?.meta?.totalRecords || 0}
          loading={loading}
          rowUniqueId="sl_no"
          rowClick={true}
          actionComponent={
            <>
              <ActionDetails val={rowData?.module_name} />
              <GlobalAnchorList
                label=""
                component={
                  <EditUimodule rowData={rowData} dispatchdata={data} />
                }
              />
              <GlobalAnchorList
                label=""
                component={
                  <DeleteUimodule id={rowData?.module_id} dispatchdata={data} />
                }
              />
            </>
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Uimodule;
